import React, { CSSProperties, PropsWithChildren } from "react";
import classnames from "classnames";

import styles from "./stack.module.css";

type StackProps = {
  flexDirection?: CSSProperties["flexDirection"];
  justifyContent?: CSSProperties["justifyContent"];
  alignItems?: CSSProperties["alignItems"];
  flexWrap?: CSSProperties["flexWrap"];
  gap?: CSSProperties["gap"];
  style?: CSSProperties;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

const Stack: React.FC<PropsWithChildren<StackProps>> = ({
  flexDirection = "row",
  justifyContent = "flex-start",
  alignItems = "stretch",
  flexWrap = "nowrap",
  gap,
  style = {},
  className,
  children,
  ...rest
}) => {
  return (
    <div
      className={classnames(styles.stack, className)}
      style={{
        display: "flex",
        flexDirection,
        justifyContent,
        alignItems,
        flexWrap,
        gap,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Stack;
